import { render, staticRenderFns } from "./GroupMembersCreate.vue?vue&type=template&id=a5fb65aa"
import script from "./GroupMembersCreate.vue?vue&type=script&lang=js"
export * from "./GroupMembersCreate.vue?vue&type=script&lang=js"
import style0 from "./GroupMembersCreate.vue?vue&type=style&index=0&id=a5fb65aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports